import { UserWms } from '../../interfaces/Picking/Picking'
import { UserDataAction } from '../actions/userDataActions'
import { GET_USER_DATA_EXITO } from '../types/userDataActionsTypes'

export interface UserDataState {
  userDataState: {
    userData?: UserWms | undefined
    error?: string | undefined
  }
}

const initialState: UserDataState = {
  userDataState: { userData: undefined, error: '' }
}

export const userDataReducer = (
  state: UserDataState = initialState,
  action: UserDataAction
): UserDataState => {
  if (action.type === GET_USER_DATA_EXITO) {
    return {
      ...state,
      userDataState: {
        userData: action.userData,
        error: action.error
      }
    }
  }
  return state
}
